import * as React from 'react'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('../pages/RootPage'))
const HeadcountPage = React.lazy(() => import('../pages/HeadcountPage'))
const InsightsPage = React.lazy(() => import('../pages/InsightsPage'))

export const insightsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.insights.path,
      element: <RootPage />,
      handle: {
        module: 'analytics',
        moduleName: () => i18n.t('sidebar.analytics'),
        meta: () => ({
          title: i18n.t('insights.section_name'),
          description: i18n.t('insights.section_description'),
          link: {
            href: helpCenterUrl('insights'),
            label: i18n.t('insights.learn_more'),
          },
          subNavigation: [
            {
              title: i18n.t('sidebar.reports'),
              href: navigation.reports.dashboards.list.fullPath(),
            },
            {
              title: i18n.t('sidebar.insights'),
              href: navigation.insights.fullPath(),
            },
          ],
        }),
      },
      children: [
        {
          index: true,
          element: <InsightsPage />,
        },
        {
          path: navigation.insights.headcount.path,

          handle: {
            meta: () => ({
              title: i18n.t('insights.pages.headcount.title'),
              description: i18n.t('insights.pages.headcount.description'),
            }),
          },
          element: <HeadcountPage />,
        },
      ],
    },
  ]
}
